/**
 * Canonical PicoX event fired by global header CTA clicks, shared by the
 * homepage header wiring (HomePageContainer) and any future consumer
 * surfaces. Schema lives in the PicoX `eventbrite` workspace with tags
 * `["creator_acquisition"]` and data purpose `service_improvement`.
 */
export const HEADER_CTA_CLICKED_EVENT = 'header_cta_clicked';

/** Canonical Janus experiment the header CTA treatments belong to. */
export const HEADER_CREATOR_EXPERIMENT_NAME = 'ebweb_header_creator_conversion_experiment';

/**
 * Nav-link heapIdentifiers (see consumer-header `DefaultNavigation`) mapped to
 * the canonical `cta` payload values. `null` skips tracking for identifiers
 * that are not experiment-relevant CTAs.
 */
const CTA_BY_HEAP_IDENTIFIER: Record<string, string> = {
    'Create Events': 'create_events',
    'Contact Sales': 'contact_sales',
    'Get Started': 'get_started',
    'Find Events': 'find_events',
    'find-my-tickets': 'find_my_tickets',
    login: 'login',
    'login-signup': 'login',
    signup: 'signup',
    Updates: 'updates',
    'Help Center': 'help_center',
    'Find your tickets': 'help_center',
    'Contact your event organizer': 'help_center',
};

export const getHeaderCtaName = (heapIdentifier: string): string | null =>
    CTA_BY_HEAP_IDENTIFIER[heapIdentifier] ?? null;
